export default "__VITE_ASSET__Ez4thcNU__"